import axios from 'axios'

export const WALLET_RESPONSE_UNCONFIRMED = 'ยังไม่ได้รับผลรายการโยกเครดิต กรุณาตรวจยอดหรือให้แอดมินตรวจสอบก่อนทำรายการซ้ำ'

// Share an in-flight request across entry points. A timeout never retries a
// financial request and never means that the provider rejected it.
export function createWalletTransferClient (http, { requestTimeout = 90000, refreshTimeout = 15000 } = {}) {
  const pending = new Map()
  return function moveWalletCredit (key, refresh) {
    if (!key) return Promise.resolve({ status: false, error: 'ไม่พบผู้ใช้งาน' })
    if (pending.has(key)) return pending.get(key)
    const run = async () => {
      let data
      try {
        const response = await http.get('https://time2lucky.apifast.xyz/qmovetowallet/move/' + encodeURIComponent(key), { timeout: requestTimeout })
        data = response && response.data
      } catch (_) {
        return { status: false, code: 'MOVE_WALLET_RESPONSE_UNCONFIRMED', error: WALLET_RESPONSE_UNCONFIRMED }
      }
      if (!data || data.status !== true) {
        return data || { status: false, code: 'MOVE_WALLET_RESPONSE_UNCONFIRMED', error: WALLET_RESPONSE_UNCONFIRMED }
      }
      let timer
      try {
        await Promise.race([
          Promise.resolve().then(refresh),
          new Promise((resolve, reject) => { timer = setTimeout(() => reject(new Error('balance_refresh_timeout')), refreshTimeout) })
        ])
      } catch (_) {
        // A failed balance refresh must not turn a confirmed transfer into a
        // failure or encourage another transfer.
        return { ...data, refreshPending: true, message: 'โยกเครดิตสำเร็จแล้ว แต่ยังรีเฟรชยอดไม่สำเร็จ กรุณากดรีเฟรชยอดอีกครั้ง' }
      } finally {
        clearTimeout(timer)
      }
      return data
    }
    const operation = run().finally(() => pending.delete(key))
    pending.set(key, operation)
    return operation
  }
}

export const moveWalletCredit = createWalletTransferClient(axios)
